<template>
  <div>
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-form-group>
      <model-select
        :options="persons"
        v-model="personId"
        :placeholder="currentUser.fullname"/>
    </b-form-group>

  </div>
</template>

<script>
  import 'vue-search-select/dist/VueSearchSelect.css'
  import { ModelSelect } from 'vue-search-select'
  import { mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasUnknownError: false,
      unknownErrorMessage: '',
      persons: []
    }),
    created () {
      this.getPersons()
    },
    methods: {
      async getPersons () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('person/GET_MY_PERSONS').then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const persons = data.userPersonen.nodes

          const renamedPersons = persons.map(person => ({
            text: person.vorname + ' ' + person.name,
            value: person.userPersonId
          }))

          renamedPersons.unshift({
            text: this.currentUser.fullname,
            value: -1
          })

          this.persons = renamedPersons
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      }
    },
    props: {
      currentUser: {
        type: Object,
        required: true
      },
      isModalEdit: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapState({
        isPersonModalVisible: state => state.application.isPersonModalVisible
      }),
      personId: {
        set (value) {
          this.$store.commit('application/SET_APPLICATION_PERSON_ID', value)
        },
        get () {
          return this.$store.state.application.createApplication.formData.personId
        }
      }
    },
    watch: {
      isPersonModalVisible (newValue, oldValue) {
        if (newValue !== oldValue && !this.isPersonModalVisible) {
          this.getPersons()
        }
      }
    },
    components: {
      ModelSelect
    }
  }
</script>
